
let intial_state=[];



const Cart_Data_reducer=(state = intial_state, action)=>{
  switch (action.type) {
    case "add":
      state.push(action.id);
      return state;
    default:
      return state;
  }
}

export default Cart_Data_reducer;